import { ArrowRight } from "lucide-react";
import CursorGlow from "@/components/landing/CursorGlow";

export default function ClosingCTA() {
  return (
    <section
      data-testid="closing-cta-section"
      className="relative py-28 sm:py-36 bg-white overflow-hidden"
    >
      <CursorGlow size={600} />
      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-8">
        <div
          data-testid="closing-cta-box"
          className="relative overflow-hidden rounded-[2rem] border border-black/10 bg-white px-8 py-16 sm:p-20 text-center"
        >
          {/* Soft blue glow center */}
          <div
            aria-hidden
            className="absolute inset-0 -z-0"
            style={{
              background:
                "radial-gradient(ellipse 60% 50% at 50% 50%, rgba(39,112,253,0.10) 0%, rgba(39,112,253,0.04) 40%, transparent 75%)",
            }}
          />
          <div
            aria-hidden
            className="absolute -top-20 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full -z-0"
            style={{
              background:
                "radial-gradient(closest-side, rgba(39,112,253,0.10), transparent 70%)",
              filter: "blur(40px)",
            }}
          />

          <div className="relative z-10">
            <span className="inline-block text-xs uppercase tracking-[0.3em] font-semibold text-[#2770FD] mb-6">
              The Final Brief
            </span>
            <h2
              data-testid="closing-cta-headline"
              className="font-display text-black text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl mx-auto"
            >
              Engineered for{" "}
              <span className="text-accent-blue">Market Dominance.</span>
            </h2>
            <p className="mt-6 max-w-2xl mx-auto text-black/70 text-base sm:text-lg font-light leading-relaxed">
              Partner with a single, highly polished execution team. Secure
              your brand&apos;s technical and aesthetic authority today.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="mailto:Connect@dynamicxmedia.com?subject=New%20Project%20Brief"
                data-testid="closing-cta-button"
                className="group inline-flex items-center gap-2 px-8 py-4 rounded-full bg-cta-solid text-white text-base font-semibold glow-cta-light transition-all duration-300 hover:-translate-y-1"
              >
                Start Your Project Now
                <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
              </a>
              <a
                href="mailto:Connect@dynamicxmedia.com"
                data-testid="closing-cta-email"
                className="text-sm font-medium text-black/70 hover:text-[#2770FD] transition-colors"
              >
                or write to Connect@dynamicxmedia.com →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
